import { render, staticRenderFns } from "./EditConfirm.vue?vue&type=template&id=49c29aa6&scoped=true"
import script from "./EditConfirm.vue?vue&type=script&lang=ts"
export * from "./EditConfirm.vue?vue&type=script&lang=ts"
import style0 from "./EditConfirm.vue?vue&type=style&index=0&id=49c29aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c29aa6",
  null
  
)

export default component.exports